<button class="btn btn-filter btn-toggle h-full" [matMenuTriggerFor]="inputMoodMenu" [ngClass]="{ 'active': selectedItems().length > 0 }">
    <app-svg name="smiley" [color]="selectedItems().length ? ss.theme().color12 : ss.theme().color7" class="me-2" style="height: 15px; width: 15px;"></app-svg>
    <span>{{ getLabel() }}</span>
    <div class="clear-icon ri-ms-2" *ngIf="selectedItems().length > 0" role="button" (click)="selectedItems.set([]); signal.set([]);$event.stopPropagation()">
        <app-svg class="d-flex align-items-center justify-content-center" name="close" [color]="ss.theme().color1"></app-svg>
    </div>
</button>
<mat-menu yPosition="above" xPosition="before" #inputMoodMenu="matMenu" class="me-menu ri-w-350px">
    <button mat-menu-item *ngFor="let mood of moods" (click)="onMoodSelected(mood, $event)">
        <div class="flex items-center justify-between">
            <span class="text-14-400 color-8 flex items-center">
                <app-svg [name]="moodEmojiMap()[mood]" [color]="ss.theme().color22" class="ri-pe-3" height="20px" width="20px"></app-svg>{{moodMap()[mood]}}
            </span>
            <!-- <app-svg *ngIf="multiple" name="tick" [color]="signal().includes(mood) ? ss.theme().color35 : ss.theme().color10"></app-svg> -->
             <app-input-checkbox [checked]="selectedItems().includes(mood)" *ngIf="multiple"></app-input-checkbox>
        </div>
    </button>
</mat-menu>